import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { UserLoginService } from "src/app/login/userlogin.service";
import { UReportListingComponent } from "src/app/real-estate/EndUser/u-listing/u-report-listing/u-report-listing.component";
import {
  PropertyListingGetPropertyDetailsRequestDTO,
  PropertyListingGetPropertyDetailsResponseDTO,
} from "src/app/real-estate/Interface & Service/property-listing/property-listing.interface";
import { PropertyListingService } from "src/app/real-estate/Interface & Service/property-listing/property-listing.service";
import {
  PropertyVisitDeleteRequestDTO,
  PropertyVisitDTO,
  PropertyVisitReadByVisitorUserIdRequestDTO,
} from "src/app/real-estate/Interface & Service/property-visit/propertyVisit.interface";
import { PropertyVisitService } from "src/app/real-estate/Interface & Service/property-visit/propertyVisit.service";
import {
  UserPropertyShortlistCheckShortlistRequestDTO,
  UserPropertyShortlistCreateRequestDTO,
  UserPropertyShortlistDeleteRequestDTO,
} from "src/app/real-estate/Interface & Service/userPropertyShortlist/userpropertyshortlist.interface";
import { UserPropertyShortlistService } from "src/app/real-estate/Interface & Service/userPropertyShortlist/userpropertyshortlist.service";
import { ConfirmmodalserviceService } from "src/app/Shared Utilities/confirm-delete-modal/confirmdeletemodal.service";
import { ScheduleVisitComponent } from "./schedule visit/schedule-visit/schedule-visit.component";
import { ListingImgPreviewComponent } from "./listing-img-preview/listing-img-preview.component";
import { AuthGuard } from "src/app/Guards/auth.guard";
import {
  REImgMasterDTO,
  REImgMasterReadByMasterIdRequestDTO,
} from "src/app/real-estate/Interface & Service/REImgMaster/reImgMaster.interface";
import { REImgMasterService } from "src/app/real-estate/Interface & Service/REImgMaster/reImgMaster.service";
import { OlaMaps } from "olamaps-web-sdk";
import { environment } from "src/environment/environment";
import { ShareListingComponent } from "./share-listing/share-listing.component";
import {
  PropertyAmenitiesDTO,
  PropertyAmenitiesReadByMasterIdRequestDTO,
} from "src/app/real-estate/Interface & Service/property-amenities/property-amenities.interface";
import { PropertyAmenitiesService } from "src/app/real-estate/Interface & Service/property-amenities/property-amenities.service";
import {
  PropertyInquiriesCheckIfUserEnquiredRequestDTO,
  PropertyInquiriesCreateRequestDTO,
  PropertyInquiriesReadByUserIdRequestDTO,
} from "src/app/real-estate/Interface & Service/property-inquiries/property-inquiries.interface";
import { PropertyInquiriesService } from "src/app/real-estate/Interface & Service/property-inquiries/property-inquiries.service";
import { UserRoleService } from "src/app/Common/UserRoleService/userRole.service";
import { UserRoleReadByUserIdRequestDTO } from "src/app/Common/UserRoleService/userRole.interface";
import { ToastrService } from "ngx-toastr";
import { ERPEntityMappingService } from "src/app/erp/ERPEntityMapping.service";
import {
  ERPEntityMappingDTO,
  ERPEntityMappingReadByMasterRequestDTO,
  ERPLeadMasterCreateRequestDTO,
} from "src/app/erp/ERPEntityMapping.interface";
import { UserAffiliationMappingReadByBusinessIdRequestDTO } from "src/app/real-estate/Interface & Service/userAffiliationMapping/userAffiliationMapping.interface";
import { UserAffiliationMappingService } from "src/app/real-estate/Interface & Service/userAffiliationMapping/userAffiliationMapping.service";

const olaMaps = new OlaMaps({
  apiKey: environment.olaAPI,
});

// Interface for grouped amenities
interface GroupedAmenity {
  category: string;
  amenities: PropertyAmenitiesDTO[];
}

@Component({
  selector: "app-listing-detail",
  templateUrl: "./listing-detail.component.html",
  styleUrls: ["./listing-detail.component.css"],
})
export class ListingDetailComponent implements OnInit {
  route = inject(ActivatedRoute);
  private propertyListingService = inject(PropertyListingService);
  private confirmationModalService = inject(ConfirmmodalserviceService);
  private propertyShortlistService = inject(UserPropertyShortlistService);
  private User = inject(UserLoginService).User();
  private AuthGuardService = inject(AuthGuard);
  private propertyVisitService = inject(PropertyVisitService);
  private propertyAmenitiesService = inject(PropertyAmenitiesService);
  private reImgMasterService = inject(REImgMasterService);
  private propertyInquiriesService = inject(PropertyInquiriesService);
  propertyVisitDetail: PropertyVisitDTO | null = null;
  private location = inject(Location);
  private toastr = inject(ToastrService);
  private erpEntityMappingService = inject(ERPEntityMappingService);
  private realEstateUserAffiliationMapping = inject(
    UserAffiliationMappingService
  );

  goBack(): void {
    this.location.back();
  }
  propertyId: number = 0;
  propertyData: PropertyListingGetPropertyDetailsResponseDTO | null = null;
  propertyImages: REImgMasterDTO[] = [];
  isLoggedIn: boolean = false;
  isShortlisted: boolean = false;
  shortListId: number = 0;
  isInquiried: boolean = false;
  contactLogId: number = 0;
  showPhoneNumber: boolean = false; // New flag to control phone number visibility
  phoneNumber: string = "+91 12345 67890"; // Static phone number (replace with propertyData?.postedByContact if available)
  private phoneNumberTimeout: any;
  showInfo = false;
  amenitiesList: PropertyAmenitiesDTO[] = [];
  groupedAmenities: GroupedAmenity[] = [];

  erpMappingInfoOfCompany: ERPEntityMappingDTO | null = null;

  erpMappingInfoOfUser: ERPEntityMappingDTO | null = null;

  /* USER ROLE */
  private userRoleService = inject(UserRoleService);

  access!: "admin" | "user";

  imgs = [
    {
      src: "https://via.placeholder.com/1200x600?text=Living+Room",
      alt: "Living Room",
    },
    {
      src: "https://via.placeholder.com/1200x600?text=Bedroom",
      alt: "Bedroom",
    },
    {
      src: "https://via.placeholder.com/1200x600?text=Pool+View",
      alt: "Pool View",
    },
    {
      src: "https://via.placeholder.com/1200x600?text=Kitchen",
      alt: "Kitchen",
    },
  ];
  current = 0;
  showMoreText = false;
  loanAmount = 8500000;
  interestRate = 8.5;
  loanTenure = 20;
  emiResult = "Your estimated monthly EMI will appear here...";

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.propertyId = Number(params["id"]);
      this.getListingDetails();
      this.getPropertyImages();
      this.getListingAmenities();
    });

    this.isLoggedIn = this.AuthGuardService.isLoggedIn();

    if (this.isLoggedIn) {
      this.checkForShortList();
      this.checkForInquiry();
      this.getPropertyVisitSchedule();
      this.getUserRoleForAccess();
    } else {
      this.access = "user";
    }
  }

  getERPMappingByMasterIdForCompany(masterType: string, businessId: number) {
    const payload: ERPEntityMappingReadByMasterRequestDTO = {
      masterType,
      masterId: businessId,
    };

    this.erpEntityMappingService
      .ERPEntityMapping_ReadByMasterId(payload)
      .subscribe({
        next: (res) => {
          this.erpMappingInfoOfCompany = res.items[0];
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  getERPMappingByMasterIdForUser(masterType: string, userId: number) {
    const payload: ERPEntityMappingReadByMasterRequestDTO = {
      masterType,
      masterId: userId,
    };

    this.erpEntityMappingService
      .ERPEntityMapping_ReadByMasterId(payload)
      .subscribe({
        next: (res) => {
          this.erpMappingInfoOfUser = res.items[0];
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  getUserRoleForAccess() {
    let data: UserRoleReadByUserIdRequestDTO = {
      userId: this.User.userId,
    };

    this.userRoleService.UserRoleService_ReadByUserId(data).subscribe((res) => {
      if (
        res.items.some(
          (role: any) =>
            role.roleId === 2 || role.roleId === 3 || role.roleId === 1
        )
      ) {
        this.access = "admin";
      } else {
        this.access = "user";
      }
    });
  }

  getListingDetails() {
    let data: PropertyListingGetPropertyDetailsRequestDTO = {
      propertyId: this.propertyId,
    };

    this.propertyListingService
      .PropertyListing_GetPropertyDetails(data)
      .subscribe((res) => {
        this.propertyData = res;

        this.getUserAffiliationMapping(res.businessId);
        this.getERPMappingByMasterIdForCompany("RealEstate", res.businessId);

        this.intiliazeOlaMaps(res.latitude, res.longitude);
        console.log(this.propertyData);
      });
  }

  getUserAffiliationMapping(businessId: number) {
    const payload: UserAffiliationMappingReadByBusinessIdRequestDTO = {
      businessId,
    };

    this.realEstateUserAffiliationMapping
      .UserAffiliationMapping_ReadByBusinessId(payload)
      .subscribe({
        next: (res) => {
          this.getERPMappingByMasterIdForUser("User", res.items[0].userId);
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  getListingAmenities() {
    let data: PropertyAmenitiesReadByMasterIdRequestDTO = {
      masterId: this.propertyId,
      masterType: "Property",
    };

    this.propertyAmenitiesService
      .PropertyAmenities_ReadByMasterId(data)
      .subscribe((res) => {
        // Filter available and active amenities
        this.amenitiesList = res.items.filter(
          (amenity: PropertyAmenitiesDTO) =>
            amenity.isAvailable === 1 && amenity.isActive === 1
        );

        // Group amenities by category
        const grouped = this.amenitiesList.reduce(
          (acc: { [key: string]: PropertyAmenitiesDTO[] }, amenity) => {
            const category = amenity.amenityCategory || "Other"; // Fallback to 'Other' if category is null
            if (!acc[category]) {
              acc[category] = [];
            }
            acc[category].push(amenity);
            return acc;
          },
          {}
        );

        // Convert grouped object to array for rendering
        this.groupedAmenities = Object.keys(grouped).map((category) => ({
          category,
          amenities: grouped[category],
        }));

        // Sort categories for consistent display (optional)
        this.groupedAmenities.sort((a, b) =>
          a.category.localeCompare(b.category)
        );
      });
  }

  getPropertyVisitSchedule() {
    let data: PropertyVisitReadByVisitorUserIdRequestDTO = {
      masterId: this.propertyId,
      masterType: "Property",
      visitorUserId: this.User.userId,
    };

    this.propertyVisitService
      .PropertyVist_ReadByVisitorUserId(data)
      .subscribe((res) => {
        this.propertyVisitDetail = res;
      });
  }

  // setCarouselImage(index: number) {
  //   this.current = index;
  //   this.updateCarousel();
  // }

  // // updateCarousel() {
  // //   const carouselImg = document.getElementById('carousel-img');
  // //   if (carouselImg) {
  // //     carouselImg.style.opacity = '0';
  // //     setTimeout(() => {
  // //       carouselImg.src = this.imgs[this.current].src;
  // //       carouselImg.alt = this.imgs[this.current].alt;
  // //       carouselImg.style.opacity = '1';
  // //     }, 200);
  // //   }
  // // }

  // startCarousel() {
  //   setInterval(() => {
  //     this.current = (this.current + 1) % this.imgs.length;
  //     this.updateCarousel();
  //   }, 5000);
  // }

  getPropertyImages() {
    let data: REImgMasterReadByMasterIdRequestDTO = {
      masterId: this.propertyId,
      masterType: "Listing",
    };

    this.reImgMasterService
      .REImgMaster_ReadByMasterId(data)
      .subscribe((res) => {
        this.propertyImages = res.items;
        console.log(this.propertyImages);
      });
  }

  toggleReadMore() {
    this.showMoreText = !this.showMoreText;
  }

  calculateEMI() {
    const loanAmount = this.loanAmount;
    const interestRate = this.interestRate / 100 / 12;
    const loanTenure = this.loanTenure * 12;
    const emi =
      (loanAmount * interestRate * Math.pow(1 + interestRate, loanTenure)) /
      (Math.pow(1 + interestRate, loanTenure) - 1);
    this.emiResult = `Your estimated monthly EMI: ₹${emi.toFixed(2)}`;
  }

  // addBusiness() {
  //   if (this.newBusiness.name && this.newBusiness.type && this.newBusiness.reraNo && this.newBusiness.panNo &&
  //       this.newBusiness.gstNo && this.newBusiness.mobile && this.newBusiness.email && this.newBusiness.address) {
  //     this.businessData.push({ ...this.newBusiness });
  //     this.newBusiness = { name: '', type: '', reraNo: '', panNo: '', gstNo: '', mobile: '', email: '', address: '' };
  //     const modal = document.getElementById('addPatientModal');
  //     if (modal) {
  //       const bsModal = bootstrap.Modal.getInstance(modal);
  //       bsModal?.hide();
  //     }
  //   }
  // }

  /* -------------------------------- SHARE TEMPLATE ---------------------------------------- */

  @ViewChild("shareTemplate") shareTemplate!: TemplateRef<any>;

  private modalService = inject(NgbModal);

  openShareModal() {
    this.modalService.open(this.shareTemplate, {
      centered: true,
      size: "md",
    });
  }

  // Existing logic
  shareLink = window.location.href;
  linkCopied = false;

  get whatsAppLink() {
    return `https://wa.me/?text=${encodeURIComponent(this.shareLink)}`;
  }

  get twitterLink() {
    return `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      this.shareLink
    )}&text=${encodeURIComponent("Check out this link:")}`;
  }

  get emailLink() {
    return `mailto:?subject=${encodeURIComponent(
      "Sharing a Property Link"
    )}&body=${encodeURIComponent(this.shareLink)}`;
  }

  copyLink() {
    const inputElement = document.getElementById(
      "shareInput"
    ) as HTMLInputElement;
    inputElement.select();
    inputElement.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(this.shareLink).then(() => {
      this.linkCopied = true;
      setTimeout(() => (this.linkCopied = false), 2000);
    });
  }

  /* -------------------------------- SHARE TEMPLATE END ---------------------------------------- */

  /* ----------------------------- SCHEDULE VISIT TEMPLATE -------------------------------------- */

  openScheduleVisitModal() {
    // Push a new state to track the modal
    history.pushState(null, "", location.href);

    const modalRef: NgbModalRef = this.modalService.open(
      ScheduleVisitComponent,
      {
        size: "xl",
      }
    );

    modalRef.componentInstance.propertyId = this.propertyId;
    modalRef.componentInstance.scheduleVisitData = this.propertyVisitDetail;

    // Listen for back button and close modal
    const popStateHandler = () => {
      modalRef.close();
    };

    window.addEventListener("popstate", popStateHandler);

    modalRef.result
      .then((result) => {
        if (result) {
          this.propertyVisitDetail = result;
        }
      })
      .catch((err) => {
        console.log("Modal dismissed", err);
      });
  }

  cancelScheduleVisit() {
    const visit = this.propertyVisitDetail;
    if (!visit) return;

    const date = new Date(visit.scheduledDate);
    const options: Intl.DateTimeFormatOptions = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    const formattedDate = date.toLocaleDateString("en-US", options); // e.g., 22 March 2026

    const time = visit.timeSlot; // function defined below
    const title = this.propertyData?.title || "this property";

    const message = `your visit for ${formattedDate} at ${time}`;

    this.confirmationModalService
      .openDeleteModal(message, visit)
      .subscribe((res) => {
        if (res) {
          const data: PropertyVisitDeleteRequestDTO = {
            visitId: visit.visitId,
            actionUser: this.User.userId.toString(),
          };

          this.propertyVisitService.PropertyVist_Delete(data).subscribe(() => {
            this.propertyVisitDetail = null;
          });
        }
      });
  }

  /* ----------------------------- SCHEDULE VISIT TEMPLATE END -------------------------------------- */

  animatedDate: string = "22 July";
  timeSlot: string = "01:30PM";

  /* ----------------------------- Listing Enquiry START -------------------------------------- */

  checkForInquiry() {
    let data: PropertyInquiriesCheckIfUserEnquiredRequestDTO = {
      masterId: this.propertyId,
      masterType: "Property",
      userId: this.User.userId,
    };

    this.propertyInquiriesService
      .PropertyInquiries_CheckIfUserEnquired(data)
      .subscribe((res) => {
        if (res.contactLogId && res.contactLogId !== 0) {
          this.isInquiried = true;
          this.contactLogId = res.contactLogId;
        }
      });
  }

  createUserInquiry() {
    let data: PropertyInquiriesCreateRequestDTO = {
      masterId: this.propertyId,
      masterType: "Property",
      userId: this.User.userId,
      ownerUserId: this.propertyData?.postedBy!,
      clickedOn: new Date(),
      actionUser: this.User.userId.toString(),
    };

    this.propertyInquiriesService
      .PropertyInquiries_Create(data)
      .subscribe((res) => {
        if (res.contactLogId && res.contactLogId !== 0) {
          this.isInquiried = true;
          this.contactLogId = res.contactLogId;
          this.showPhoneNumber = true; // Show phone number after inquiry
          // Hide phone number after 10 seconds
          this.phoneNumberTimeout = setTimeout(() => {
            this.showPhoneNumber = false;
          }, 10000); // 10 seconds
        }
      });
  }

  onContactClick() {
    if (this.isInquiried) {
      // Show phone number temporarily
      this.showPhoneNumber = true;
      // Clear any existing timeout to avoid overlap
      if (this.phoneNumberTimeout) {
        clearTimeout(this.phoneNumberTimeout);
      }
      // Hide phone number after 10 seconds
      this.phoneNumberTimeout = setTimeout(() => {
        this.showPhoneNumber = false;
      }, 10000); // 10 seconds
    } else {
    // Trigger inquiry creation
    this.createUserInquiry();

    if (!this.erpMappingInfoOfCompany || !this.propertyData || !this.erpMappingInfoOfUser) {
      alert("ERP mapping or property data not found!");
      return;
    }

    const data: ERPLeadMasterCreateRequestDTO = {
      companyId: this.erpMappingInfoOfCompany.erpId,
      branchId: this.erpMappingInfoOfCompany.branchId,
      leadCompanyId: this.erpMappingInfoOfCompany.erpId,
      leadCompanyName: "",
      crmProduct: this.propertyData.title,
      leadOwner: this.erpMappingInfoOfUser.erpId.toString(),
      leadStatus: "Open",
      leadPriority: "",
      leadDate: new Date(),
      actionUser: this.User.userId.toString(),
    };

    this.createLead(data);
    }
  }

  createLead(data: ERPLeadMasterCreateRequestDTO) {
    this.erpEntityMappingService.ERPLeadMaster_Create(data).subscribe({
      next: (res) => {
        this.toastr.success("The lead request send successfully 🎉");
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  /* ----------------------------- Listing Enquiry END -------------------------------------- */

  /* ----------------------------- Listing Shortlist -------------------------------------- */

  checkForShortList() {
    let data: UserPropertyShortlistCheckShortlistRequestDTO = {
      userId: this.User.userId,
      masterId: this.propertyId,
      masterType: "Property",
    };

    this.propertyShortlistService
      .UserPropertyShortlist_CheckShortlist(data)
      .subscribe((res) => {
        if (res.shortlistId && res.shortlistId !== 0) {
          this.isShortlisted = true;
          this.shortListId = res.shortlistId;
        }
      });
  }

  toggleShortlist() {
    if (this.isShortlisted) {
      this.removeFromShortlist();
    } else {
      this.addToShortlist();
    }
  }

  addToShortlist() {
    let data: UserPropertyShortlistCreateRequestDTO = {
      userId: this.User.userId,
      masterId: this.propertyId,
      masterType: "Property",
      shortlistedOn: new Date(),
      remarks: "",
      actionUser: this.User.userId.toString(),
    };

    this.propertyShortlistService.UserPropertyShortlist_Create(data).subscribe({
      next: (res) => {
        this.isShortlisted = true;
        this.shortListId = res.shortlistId;
      },
      error: (err) => {
        console.error("Failed to shortlist", err);
      },
    });
  }

  removeFromShortlist() {
    let data: UserPropertyShortlistDeleteRequestDTO = {
      shortlistId: this.shortListId,
      actionUser: this.User.userId.toString(),
    };

    this.propertyShortlistService.UserPropertyShortlist_Delete(data).subscribe({
      next: (res) => {
        this.isShortlisted = false;
        this.shortListId = 0;
      },
      error: (err) => {
        console.error("Failed to remove from shortlist", err);
      },
    });
  }

  /* ----------------------------- Listing Shortlist END -------------------------------------- */

  /* ----------------------------- Report Listing Start -------------------------------------- */
  openReportListingModal() {
    history.pushState(null, "", location.href);

    const modalRef: NgbModalRef = this.modalService.open(
      UReportListingComponent,
      {
        size: "lg",
      }
    );

    modalRef.componentInstance.propertyId = this.propertyId;

    const popStateHandler = () => {
      modalRef.close();
    };

    window.addEventListener("popstate", popStateHandler);

    modalRef.result
      .then((result) => {
        if (result) {
        }
      })
      .catch((err) => {
        console.log("Modal Dismissed", err);
      });
  }

  /* ----------------------------- Report Listing END -------------------------------------- */

  /* ----------------------------- Listing Shortlist START -------------------------------------- */

  openImgPreviewModal() {
    history.pushState(null, "", location.href);

    const modalRef: NgbModalRef = this.modalService.open(
      ListingImgPreviewComponent
    );

    modalRef.componentInstance.propertyImages = this.propertyImages;
    modalRef.componentInstance.propertyTitle = this.propertyData?.title;
  }

  /* ----------------------------- Listing Shortlist END -------------------------------------- */

  /* ----------------------------- OLAMAPS START -------------------------------------- */
  myMap!: any;
  olaMarker: any;
  olaPopUp: any;

  intiliazeOlaMaps(lat: number, log: number) {
    this.myMap = olaMaps.init({
      style:
        "https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json",
      container: "map",
      center: [lat, log],
      zoom: 15,
    });

    const popup = olaMaps
      .addPopup({ offset: [0, -30], anchor: "bottom" })
      .setHTML("<div>This is a simple Popup</div>");

    this.olaMarker = olaMaps
      .addMarker({
        offset: [0, 6],
        anchor: "bottom",
        color: "red",
        draggable: true,
      })
      .setLngLat([lat, log])
      .setPopup(popup)
      .addTo(this.myMap);
  }

  /* ----------------------------- OLAMAPS END -------------------------------------- */

  /* ----------------------------- OPEN SHARE LISTING -------------------------------------- */
  openShareListingModal() {
    history.pushState(null, "", location.href);

    const modalRef: NgbModalRef = this.modalService.open(ShareListingComponent);

    modalRef.componentInstance.link = window.location.href;
    modalRef.componentInstance.propertyData = this.propertyData;
    modalRef.componentInstance.access = this.access ?? "user";
    modalRef.componentInstance.header = "Share This Property";
    modalRef.componentInstance.subHeader =
      "Send this property link to your friends & family.";
  }

  /* ----------------------------- OPEN SHARE END -------------------------------------- */

  formatIndianCurrency(amount: number): string {
    if (!amount || amount < 0) return "";
    if (amount >= 10000000) {
      const crores = amount / 10000000;
      return crores % 1 === 0 ? `${crores}Cr` : `${crores.toFixed(1)}Cr`;
    } else if (amount >= 100000) {
      const lakhs = amount / 100000;
      return lakhs % 1 === 0 ? `${lakhs}L` : `${lakhs.toFixed(1)}L`;
    } else if (amount >= 1000) {
      const thousands = amount / 1000;
      return thousands % 1 === 0 ? `${thousands}K` : `${thousands.toFixed(1)}K`;
    } else {
      return amount.toLocaleString("en-IN");
    }
  }
}
